import { z } from "zod";
import { CTA_TYPES } from "./cta.js";
import { contentTargetingBaseSchema } from "./content-targeting.js";
import { plainTextField } from "./public-api.js";
import { validateDateWindow } from "./validation.js";
export const SPONSORED_PLACEMENT = "login_sponsored";
export const DEFAULT_SPONSORSHIP_LABEL = "آگهی";
export const SPONSORED_IMAGE_MAX_BYTES = 256 * 1024;
export const SPONSORED_IMAGE_MAX_EDGE_PX = 1200;
export const SPONSORED_CAMPAIGN_MAX_DURATION_MS = 90 * 24 * 60 * 60 * 1000;
export const ADVERTISER_STATUSES = ["active", "archived"];
export function validateSponsoredDuration(startsAt, endsAt) {
    if (!startsAt || !endsAt) {
        return { ok: false, error: "Campaign start and end times are required" };
    }
    if (!validateDateWindow(startsAt, endsAt)) {
        return { ok: false, error: "End time must be after start time" };
    }
    if (endsAt.getTime() - startsAt.getTime() > SPONSORED_CAMPAIGN_MAX_DURATION_MS) {
        return { ok: false, error: "Campaign duration cannot exceed 90 days" };
    }
    return { ok: true, startsAt, endsAt };
}
export const createAdvertiserSchema = z.object({
    displayName: plainTextField(80),
    internalNotes: plainTextField(500).nullable().optional(),
});
export const updateAdvertiserSchema = z.object({
    displayName: plainTextField(80).optional(),
    internalNotes: plainTextField(500).nullable().optional(),
});
const sponsoredScheduleSchema = z.object({
    startsAt: z.string().datetime(),
    endsAt: z.string().datetime(),
});
const sponsoredCreativeFieldsSchema = z.object({
    headline: plainTextField(80),
    description: plainTextField(160),
    offerText: plainTextField(40).nullable().optional(),
    sponsorshipLabel: plainTextField(40).optional(),
    imagePath: z.string().min(1),
    imageAlt: plainTextField(120),
    ctaType: z.enum(CTA_TYPES),
    ctaLabel: plainTextField(60),
    customApprovedUrl: z.string().url().optional(),
});
export const createSponsoredCampaignSchema = z
    .object({
    advertiserId: z.string().min(1),
    name: plainTextField(120),
    placement: z.literal(SPONSORED_PLACEMENT).optional(),
})
    .merge(sponsoredCreativeFieldsSchema)
    .merge(contentTargetingBaseSchema)
    .merge(sponsoredScheduleSchema);
export const updateSponsoredCampaignSchema = createSponsoredCampaignSchema.partial();
//# sourceMappingURL=sponsored.js.map